import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CustomerService } from 'src/app/Service/Customer/Customer.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-CutomerCommentCheck',
  templateUrl: './CutomerCommentCheck.component.html',
  styleUrls: ['./CutomerCommentCheck.component.scss']
})
export class CutomerCommentCheckComponent implements OnInit {


  constructor(
    private Customer_Service:CustomerService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService,
  ) { }

  Token:String=""
  Priority:String="0"
  page:number=0;
  Procssing:boolean=false



  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token,1121).subscribe(
      data=>{

      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )
  }

  DataList_Comment:Array<General_Interface>=[]
  Data_Seleted_Comment:General_Interface=Empty_General_Interface()
  Operation:number=0

  Read_Comments(){
    this.Procssing=true
    this.Customer_Service.GetCustomerCommentCheck(this.Token).subscribe(
      data=>{
        this.Procssing=false
        this.DataList_Comment=data
      }
    )
  }

  modalRef_Operation:any
  openModal(template: TemplateRef<any>,item:General_Interface,Operatin:number) {
    this.Data_Seleted_Comment=item
    this.Operation=Operatin
    this.Priority="0"
    this.modalRef_Operation = this.modalService.show(template);
  }

  OnOperation(){
    this.Data_Seleted_Comment.DeletingProccess=true
    this.modalRef_Operation.hide()
    this.Customer_Service.CommentStatus(this.Data_Seleted_Comment.id,this.Operation,Number(this.Priority),this.Token).subscribe(
      data=>{
        if(this.Operation==1)
          this.Alertify_Service.SuccessMessage("Approved successfully.")
        else
          this.Alertify_Service.SuccessMessage("Rejected successfully.")
        this.Read_Comments()
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  EditDsc:String=''
  modalRef_Edit:any
  openModal_Edit(template: TemplateRef<any>, item: General_Interface) {
    this.EditDsc=item.title
    this.Data_Seleted_Comment=item
    this.modalRef_Edit = this.modalService.show(template);
  }

  Edit(){
    this.Data_Seleted_Comment.DeletingProccess=true
    this.modalRef_Edit.hide()
    this.Customer_Service.CommentEdit(this.Data_Seleted_Comment.id,this.EditDsc,this.Token).subscribe(
      data=>{
        this.Alertify_Service.SuccessMessage("Updated successfully.")
        this.Data_Seleted_Comment.title = data['dsc']
        this.Data_Seleted_Comment.DeletingProccess=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }


}
